import React from 'react'
import { withRouter } from "react-router-dom";
import { FormComponent } from '../../../../components/form/DynamicForm';
import { Form, Validators } from '../../../../components/form/DynamicFormTs';
import Http from '../../../../Http';
import CfdiContacto from './CfdiContacto'
// import Http from '../../../../Http';

class ClieteCfdi extends FormComponent {
  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'cliente/one', saveUrl: 'cliente/save', backUrl: '/Catalogo/Cliente/' + this.props.match.params.id + '/ClieteCfdi' },
      new Form([
        Form.Field('select', 'cliente_cfdi_uso', 'Uso CFDI', '', [Validators.required], 6),
        Form.Field('select', 'cliente_forma_pago', 'Forma de pago', '', [Validators.required], 6),
        Form.Field('select', 'cliente_metodo_pago', 'Metodo de pago', '', [Validators.required], 6),
        Form.Field('select', 'cliente_id_regimen_fiscal', 'Régimen Fiscal', '', [Validators.required], 6),
        Form.Field('checkbox', 'cliente_fc_concepto', 'Usar concepto manual', '', [], 12),
        Form.Section('Addenda'),
        Form.Field('textarea', 'cliente_formato_addenda', 'Formato Addenda', '', [], 12),
      ], ['Guardar']), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds(this.props.match.params.id)
  }

  formData = async (form, ejecutivo = null) => {
    const Res = await Http.get(`cliente/form/cfdi`);
    if (!Res.error) {
      let newForm = Form.FieldOptions(form, 'cliente_cfdi_uso', Res.data.cfdi_usos, 'id', 'cfdi_uso_nombre');
      newForm = Form.FieldOptions(newForm, 'cliente_forma_pago', Res.data.formas_pago, 'id', 'forma_nombre');
      newForm = Form.FieldOptions(newForm, 'cliente_metodo_pago', Res.data.metodos_pago, 'id', 'metodo_nombre');
      newForm = Form.FieldOptions(newForm, 'cliente_id_regimen_fiscal', Res.data.regimenes_fiscales, 'id', 'label');
      return newForm;
    }
  }

  render() {
    return (
      <div>
        <this.FormRender />
        <CfdiContacto />
      </div>
    )
  }
}

export default withRouter(ClieteCfdi)
